import React from 'react'
import { cn } from '../../lib/helpers'
import * as styles from './Button.module.css'
import PropTypes from 'prop-types'
import { ArrowRightIcon } from '../icons/ArrowRightIcon'

/**
 * Unified button component.
 *
 * @param {'filled'|'outline'} variant  - Visual style. Default: 'filled'.
 * @param {'dark'|'light'}     color    - Color scheme. Default: 'dark'.
 *   - filled + dark  → dark teal background (primary)
 *   - filled + light → soft teal background (secondary)
 *   - outline + dark → dark teal border, for light backgrounds
 *   - outline + light→ white border, for dark/teal backgrounds
 *
 * Backward compatible: the old boolean `color` prop still works
 * and maps to the 'filled light' variant.
 */
export const Button = ({ className, onClick, buttonText, variant = 'filled', color = 'dark', centered, withArrow }) => {
  let styleClass

  if (variant === 'outline' || variant === 'outlined') {
    styleClass = color === 'light' ? styles.outlineLight : styles.outlineDark
  } else {
    // filled (default) — legacy boolean `color` prop maps to filledLight
    styleClass = (color === 'light' || color === true) ? styles.filledLight : styles.filledDark
  }

  return (
    <button
      onClick={onClick}
      className={cn(styleClass, centered ? styles.buttonCentered : '', className)}
    >
      {buttonText}
      {withArrow ? <ArrowRightIcon aria-hidden /> : null}
    </button>
  )
}

Button.defaultProps = {
  variant: 'filled',
  color: 'dark',
  withArrow: false,
}

Button.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['filled', 'outline', 'outlined']),
  color: PropTypes.oneOfType([
    PropTypes.oneOf(['dark', 'light']),
    PropTypes.bool,
  ]),
  centered: PropTypes.bool,
  withArrow: PropTypes.bool,
}
